<div style="display: flex;flex-direction: row;">
  <h2 mat-dialog-title style="display: inline;flex: auto;">Konsulent</h2>
  <button mat-button mat-dialog-close>X</button>
</div>
<mat-dialog-content>
  @if (!loading) {
  <div>
    <div class="form-row">
      <mat-form-field appearance="outline">
        <mat-label>Navn</mat-label>
        <input matInput type="text" [(ngModel)]="consultant.name" required>
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Initialer</mat-label>
        <input matInput type="text" [(ngModel)]="consultant.initials" (ngModelChange)="checkExisting()"
          [readonly]="consultant.id" required>
      </mat-form-field>
      @if (consultantExists) {
      <mat-error>Disse initialer er allerede benyttet</mat-error>
      }

    </div>
    <div class="form-row">
      <mat-form-field appearance="outline">
        <mat-label>Email</mat-label>
        <input matInput type="text" [(ngModel)]="consultant.email" required email>
      </mat-form-field>
    </div>

    <app-autocomplete-chips [formControl]="departmentControl" label="Forretningsområde"
      [displayFn]="departmentsService.displayFn" [valueFn]="departmentsService.valueFn" [options]="departments"
      [multiple]="false" [required]="true"></app-autocomplete-chips>

    <h3>Lønomkostninger pr. år</h3>
    @for (salary of salaries; track salary) {
    <div class="form-row">
      <mat-form-field appearance="outline">
        <mat-label>År</mat-label>
        <input matInput [(ngModel)]="salary.year">
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>Position</mat-label>
        <mat-select [ngModel]="salary.position" (ngModelChange)="onPositionChange(salary, $event)">
          <mat-option [value]="Position.None">Ingen</mat-option>
          <mat-option [value]="Position.Ledelseskonsulent">Ledelseskonsulent</mat-option>
          <mat-option [value]="Position.Chefkonsulent">Chefkonsulent</mat-option>
          <mat-option [value]="Position.Partner">Partner</mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>Månedlige lønomkostninger</mat-label>
        <input matInput [(ngModel)]="salary.monthlySalary" currencyFormat="1.0-2" enterNavigation calculatorInput>
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>Månedlige fællesomkostninger</mat-label>
        <input matInput [(ngModel)]="salary.monthlySharedExpenses" currencyFormat="1.0-2" enterNavigation calculatorInput>
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>Bonus %</mat-label>
        <input matInput type="number" [(ngModel)]="salary.bonusPercentage"
          [disabled]="salary.position === Position.None || salary.position == null" enterNavigation>
      </mat-form-field>
      <button mat-icon-button (click)="deleteSalary($index)" matTooltip="Slet">
        <mat-icon>delete</mat-icon>
      </button>
    </div>
    }

    <button mat-raised-button color="primary" style="width: fit-content;" (click)="addSalary()">
      <mat-icon>add</mat-icon>
      Tilføj
    </button>

    <h3 style="margin-top: 1rem;">Budget personlig omsætning</h3>
    @for (budget of consultant.budgetPersonalSales; track budget) {
    <div class="form-row">
      <mat-form-field appearance="outline">
        <mat-label>År</mat-label>
        <input matInput [(ngModel)]="budget.year">
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>Budget</mat-label>
        <input matInput [(ngModel)]="budget.amount" currencyFormat="1.0-2" enterNavigation calculatorInput>
      </mat-form-field>
      <button mat-icon-button (click)="deletePersonalSalesBudget($index)" matTooltip="Slet">
        <mat-icon>delete</mat-icon>
      </button>
    </div>
    }

    <button mat-raised-button color="primary" style="width: fit-content;" (click)="addPersonalSalesBudget()">
      <mat-icon>add</mat-icon>
      Tilføj
    </button>

    <h3 style="margin-top: 1rem;">Budget totalsalg</h3>
    @for (budget of consultant.budgetTotalSales; track budget) {
    <div class="form-row">
      <mat-form-field appearance="outline">
        <mat-label>År</mat-label>
        <input matInput [(ngModel)]="budget.year">
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>Budget</mat-label>
        <input matInput [(ngModel)]="budget.amount" currencyFormat="1.0-0" enterNavigation calculatorInput>
      </mat-form-field>
      <button mat-icon-button (click)="deleteTotalSalesBudget($index)" matTooltip="Slet">
        <mat-icon>delete</mat-icon>
      </button>
    </div>
    }

    <button mat-raised-button color="primary" style="width: fit-content;" (click)="addTotalSalesBudget()">
      <mat-icon>add</mat-icon>
      Tilføj
    </button>

    <div class="form-row" style="margin-top: 1rem;">
      <mat-checkbox [(ngModel)]="consultant.dashboardAccess">Dashboard adgang</mat-checkbox>
      <mat-checkbox [(ngModel)]="consultant.includedInDashboard">Medtaget i dashboard</mat-checkbox>
    </div>

  </div>

  }
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-raised-button color="primary" mat-dialog-close>Annuller</button>
  <button mat-raised-button color="primary" (click)="save()" [disabled]="!valid()">Gem</button>
</mat-dialog-actions>